import { useCart } from '../context/CartContext';
import { useI18n } from '../i18n';

export function OrderConfirmation() {
  const { setView } = useCart();
  const { t } = useI18n();

  return (
    <div className="hc-confirmation">
      <div className="hc-confirmation-icon">&#10003;</div>
      <h2>{t('status.approved')}</h2>
      <button className="hc-btn hc-btn-primary" onClick={() => setView('menu')}>
        {t('status.newOrder')}
      </button>
    </div>
  );
}
